module.exports = __webpack_public_path__ + "img/corbieres-web-logo.fc7ae9a1.svg";